import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useHighlight = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const highlightText = params.get('highlightText');

    if (highlightText) {
      const targetText = highlightText.replace(/\s+/g, ' ').trim().toLowerCase();
      
      const getDeepestElementWithText = (text) => {
        const elements = Array.from(document.querySelectorAll('body *'));
        let deepest = null;
        let maxDepth = -1;

        for (const el of elements) {
          if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'SVG', 'PATH'].includes(el.tagName)) continue;

          // Normalize element text (replace newlines/nbsps/multiple spaces with single space)
          const elText = (el.textContent || '').replace(/\s+/g, ' ').toLowerCase();
          
          if (elText.includes(text)) {
            // Find depth
            let depth = 0;
            let curr = el;
            while (curr.parentNode) {
              depth++;
              curr = curr.parentNode;
            }
            
            if (depth > maxDepth) {
              maxDepth = depth;
              deepest = el;
            }
          }
        }
        return deepest;
      };

      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (attempts > 20) { // Give up after 10 seconds
          console.warn(`[useHighlight] Could not find text after 10 seconds.`);
          clearInterval(interval);
          return;
        }

        const targetElement = getDeepestElementWithText(targetText);
        
        if (targetElement) {
          clearInterval(interval);
          
          // Force un-hide target and all its ancestors
          let curr = targetElement;
          while (curr && curr !== document.body) {
            if (curr.tagName === 'DETAILS') {
              curr.open = true;
            }
            const compStyle = window.getComputedStyle(curr);
            if (compStyle.display === 'none') {
              curr.style.setProperty('display', 'block', 'important');
            }
            if (compStyle.opacity === '0' || compStyle.opacity === 0) {
              curr.style.setProperty('opacity', '1', 'important');
            }
            if (compStyle.visibility === 'hidden') {
              curr.style.setProperty('visibility', 'visible', 'important');
            }
            curr = curr.parentElement;
          }
          
          targetElement.style.transition = 'all 0.5s ease-in-out';
          targetElement.style.backgroundColor = '#ffff00'; // Yellow
          targetElement.style.boxShadow = '0 0 0 4px #ffff00';
          targetElement.style.borderRadius = '4px';
          targetElement.style.color = '#000000';
          
          // Small delay to let browser reflow after un-hiding elements
          setTimeout(() => {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 100);
        }
      }, 500);

      return () => clearInterval(interval);
    }
  }, [location.search]);
};

export default useHighlight;
